const _ = require('lodash');

const languages = {
	en: 'en',
	ru: 'ru',
	uk: 'uk',
	de: 'de',
	vi: 'vi',
	th: 'th'
};

let locale = {
	ru: {
		en: 'английский',
		ru: 'русский',
		uk: 'украинский',
		de: 'немецкий',
		vi: 'вьетнамский',
		th: 'тайский'
	},
	uk: {
		en: 'англійська',
		ru: 'російська',
		uk: 'українська',
		de: 'німецька',
		vi: 'вьетнамська',
		th: 'тайська'
	},
	en: {
		en: 'English',
		ru: 'Russian',
		uk: 'Ukrainian',
		de: 'German',
		vi: 'Vietnamese',
		th: 'Thai'
	},
	de: {
		en: 'English',
		ru: 'Russian',
		uk: 'Ukrainian',
		de: 'Deutsch',
		vi: 'Vietnamesisch',
		th: 'Thai'
	},
	vi: {
		en: 'Anh',
		ru: 'Người Nga',
		uk: 'tiếng Ukraina',
		de: 'tiếng Đức',
		vi: 'Tiếng Việt',
		th: 'Tiếng Thái'
	},
	th: {
		en: 'อังกฤษ',
		uk: 'ภาษายูเครน',
		ru: 'รัสเซีย',
		de: 'เยอรมัน',
		vi: 'เวียตนาม',
		th: 'ไทย'
	}
};

if (process.env.CPA_ENV === 'rocket') {
	delete languages.uk;
	locale = _.mapValues(locale, val => _.omit(val, [ 'uk' ]));
}

module.exports = {
	enum: languages,
	locale: locale
};



// WEBPACK FOOTER //
// ./enums/languages.js